import { HaftpflichtSchadenKfz } from '@gsm/entities';
import { DynamicFormControlLayout, serializable } from '@ng-dynamic-forms/core';
import { BaseHaftpflichtSchadenModel, BaseHaftpflichtSchadenModelConfig } from '../shared-models/haftpflichtschaden.model';

export const TYPE_HAFTPFLICHT_KFZ_SCHADEN = 'HAFTPFLICHT-KFZ-SCHADEN';

export type HaftpflichtKfzSchadenModelConfig = BaseHaftpflichtSchadenModelConfig<HaftpflichtSchadenKfz>;

export class HaftpflichtKfzSchadenModel extends BaseHaftpflichtSchadenModel<HaftpflichtSchadenKfz> {
  @serializable() readonly type: string = TYPE_HAFTPFLICHT_KFZ_SCHADEN;

  constructor(config: HaftpflichtKfzSchadenModelConfig, layout?: DynamicFormControlLayout) {
    super(config, layout);
    // additional is set from super()
  }
}
